// extracted by mini-css-extract-plugin
module.exports = {"table":"ReaderFirmwareTabPane_table__181lb","button":"ReaderFirmwareTabPane_button__1utcW"};